var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.8583 7.42868L20.5718 7.14222C20.3822 6.95259 20.0756 6.95259 19.8859 7.14222L12.0023 15.0299L4.11457 7.14222C3.92494 6.95259 3.61831 6.95259 3.42868 7.14222L3.14222 7.42868C2.95259 7.61831 2.95259 7.92494 3.14222 8.11457L11.6553 16.6317C11.8449 16.8213 12.1515 16.8213 12.3412 16.6317L20.8542 8.11457C21.0479 7.92494 21.0479 7.61831 20.8583 7.42868Z","fill":"#1B1F24"}));
}

ChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
